import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, withKeys as _withKeys, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "layout--column column--right login" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "heading-container" }
const _hoisted_6 = {
  key: 0,
  class: "button"
}
const _hoisted_7 = { href: "/register" }
const _hoisted_8 = {
  key: 1,
  class: "or"
}

import { ref, onBeforeMount, onMounted, nextTick } from 'vue'
import CredentialsForm from '@/components/CredentialsForm.vue'
import Input from '@/components/Input.vue'
import BaseButton from '@/components/BaseButton.vue'
import { LoginData } from '@/pages/login/entities/login'
import { loginUser } from '@/api/login'
import GrecaptchaBox from '@/components/GrecaptchaBox.vue'
import Checkbox from '@/components/Rain/Inputs/Checkbox.vue'
import MFASetup from '@/components/Settings/MFASetup.vue'
import MFASetupOk from '@/pages/login/MFASetupOk.vue'
import MFAVerifyRecoveryCode from '@/pages/login/MFAVerifyRecoveryCode.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const DISABLED_SUBDOMAINS: string[] = ['asknicely']

const email = ref('')
const password = ref('')
const mfa = ref('')
const mfaRememberDevice = ref(false)
const loginData = ref<LoginData | undefined>()
const error = ref('')
const mfaLogin = ref(false)
const mfaEnforce = ref(false)
const mfaQrCode = ref('')
const mfaSecret = ref('')
const mfaSuccess = ref(false)
const isMfaRecoveryPage = ref(false)
const recoveryCodes = ref<string[]>([])
const recoveryCode = ref('')
const isLoading = ref(true)
const redirectUrl = ref('')

const emailRef = ref<typeof Input | null>(null)
const passwordRef = ref<typeof Input | null>(null)
const mfaRef = ref<HTMLInputElement | null>(null)
const grecaptchaRef = ref<typeof GrecaptchaBox | null>(null)

onBeforeMount(async () => {
    const dataEl = document.getElementById('login-data')
    const dataJson = dataEl && dataEl.getAttribute('data-json')
    const data: LoginData = dataJson && JSON.parse(dataJson)

    loginData.value = data
    error.value = data.error
})

const login = async () => {
    error.value = ''
    let recaptchaResponse = ''

    if (loginData.value?.hasRecaptcha) {
        recaptchaResponse = grecaptchaRef.value?.getResponse() || ''
        if (recaptchaResponse.length < 1) {
            error.value = 'Please complete reCAPTCHA challenge'
            return
        }
    }

    if (loginData.value?.redirect) {
        redirectUrl.value = loginData.value.redirect
    }

    if (!mfaLogin.value && !mfaEnforce.value) {
        emailRef.value!.hasFocused = true
        passwordRef.value!.hasFocused = true
    }

    if (password.value === '' || !email.value.match(/.+@.+\..+/)) {
        return
    }

    if (mfaLogin.value && mfa.value === '') {
        return
    }

    try {
        const { data } = await loginUser(
            email.value,
            password.value,
            loginData.value?.redirect ? redirectUrl.value : undefined,
            mfaLogin.value || mfaEnforce.value ? mfa.value : undefined,
            loginData.value?.hasRecaptcha ? recaptchaResponse : undefined,
            mfaLogin.value ? mfaRememberDevice.value : undefined,
            recoveryCode.value
        )
        if (data.mfa) {
            mfaLogin.value = true
            nextTick(() => {
                mfaRef.value?.focus()
            })
        } else if (data.mfaEnforce) {
            mfaEnforce.value = true
            mfaQrCode.value = data.codeUrl
            mfaSecret.value = data.mfaSecret
        } else if (data.recoveryCodes) {
            recoveryCodes.value = data.recoveryCodes
            mfaSuccess.value = true
            isLoading.value = false
            redirectUrl.value = data.redirect
        } else {
            redirectTo(data.redirect)
        }
    } catch (e: any) {
        error.value = e.response.data.error
    }
}

const verifyRecoveryCode = async () => {
    try {
        error.value = ''
        let recaptchaResponse = ''

        const { data } = await loginUser(
            email.value,
            password.value,
            mfaLogin.value || mfaEnforce.value ? mfa.value : undefined,
            loginData.value?.hasRecaptcha ? recaptchaResponse : undefined,
            mfaLogin.value ? mfaRememberDevice.value : undefined,
            recoveryCode.value
        )

        if (data.recoveryCodes) {
            recoveryCodes.value = data.recoveryCodes
            mfaSuccess.value = true
            isLoading.value = false
            redirectUrl.value = data.redirect
        } else {
            redirectTo(data.redirect)
        }
    } catch (e: any) {
        error.value = e.response.data.error
    }
}

const mfaValidateLogin = (mfaCode: string) => {
    if (!mfaCode || mfaCode.length !== 6) {
        error.value = 'Please enter your 6 digit MFA code'
        return
    }
    mfa.value = mfaCode
    login()
}

const onDownloadRecoveryCodes = () => {
    const dataAsString = recoveryCodes.value.join('\n')
    const blob = new Blob([dataAsString], { type: 'text/plain' })
    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = 'recovery-codes.txt'
    document.body.appendChild(link)

    link.click()

    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
}

onMounted(() => {
    window.addEventListener('keydown', (e) => {
        const isCommandG = (e.metaKey || e.ctrlKey) && e.key === 'g'
        const subDomain = window.location.host.split('.')[0]
        const notDisabled = DISABLED_SUBDOMAINS.indexOf(subDomain) === -1
        if (notDisabled && isCommandG && loginData.value?.enabledGLogin) {
            e.preventDefault()
            redirectTo(loginData.value.asknicelyLoginUrl)
        }
    })
})

const mfaCancel = () => {
    error.value = ''
    mfaEnforce.value = false
    mfaQrCode.value = ''
    mfaSecret.value = ''
    isMfaRecoveryPage.value = false
    recoveryCode.value = ''
}

const redirectTo = (link: string) => {
    return location.replace(link)
}

const onChangeRememberDevice = (value: boolean): void => {
    mfaRememberDevice.value = value
}

const onLostAuthenticatorLink = (): void => {
    isMfaRecoveryPage.value = true
}

const onVerifyRecoveryCode = (code: string) => {
    if (!code) {
        error.value = 'Recovery code required.'
        return
    }
    recoveryCode.value = code
    verifyRecoveryCode()
}

const onDone = () => {
    redirectTo(redirectUrl.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"layout--column column--left\" data-v-6cb49f66><div class=\"column--left--content\" data-v-6cb49f66><p class=\"column--left--content--title column--left--content--desktop\" data-v-6cb49f66><span class=\"bold-text\" data-v-6cb49f66>Meet the future of CX</span></p><p class=\"column--left--content--description column--left--content--desktop\" data-v-6cb49f66> The new Transform plan helps your team <br data-v-6cb49f66>act on feedback, improve every day and <br data-v-6cb49f66> hit your CX goals faster. </p><p class=\"column--left--content--title column--left--content--mobile\" data-v-6cb49f66><span class=\"bold-text\" data-v-6cb49f66>Meet the future of CX</span></p><p class=\"column--left--content--description column--left--content--mobile\" data-v-6cb49f66> The new Transform plan helps your team <br data-v-6cb49f66>act on feedback, improve every day and <br data-v-6cb49f66> hit your CX goals faster. </p><a href=\"https://www.asknicely.com/product-tour?utm_source=product&amp;utm_medium=login&amp;utm_campaign=project-copilot\" target=\"_blank\" class=\"column--left--content--button\" data-v-6cb49f66>See it in action</a></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "layout--content login-form",
        onKeyup: _withKeys(login, ["enter"])
      }, [
        _withDirectives(_createElementVNode("div", { class: "error" }, _toDisplayString(error.value), 513), [
          [_vShow, error.value]
        ]),
        _createVNode(CredentialsForm, {
          logo: loginData.value.logo,
          class: "login-form--credentials-form"
        }, {
          default: _withCtx(() => [
            (mfaEnforce.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (mfaSuccess.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(MFASetupOk, {
                          "is-loading": isLoading.value,
                          codes: recoveryCodes.value,
                          "from-mfa-setup": true,
                          onOnDone: onDone,
                          onOnDownload: onDownloadRecoveryCodes
                        }, null, 8, ["is-loading", "codes"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(MFASetup, {
                          email: email.value,
                          password: password.value,
                          "qr-url": mfaQrCode.value,
                          "mfa-secret": mfaSecret.value,
                          onMfaUpdate: mfaValidateLogin,
                          onMfaCancel: mfaCancel
                        }, null, 8, ["email", "password", "qr-url", "mfa-secret"])
                      ]))
                ], 64))
              : (!mfaLogin.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (loginData.value.emailLoginEnabled)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_5, [
                            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "heading" }, "Sign In", -1)),
                            (loginData.value.canSelfRegister)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                  _createElementVNode("a", _hoisted_7, [
                                    _createVNode(BaseButton, {
                                      white: "",
                                      bordered: ""
                                    }, {
                                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                                        _createTextVNode("Register")
                                      ]), undefined, true),
                                      _: 1
                                    })
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(Input, {
                            ref_key: "emailRef",
                            ref: emailRef,
                            modelValue: email.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                            title: "Email",
                            placeholder: "Email",
                            regex: /.+@.+\..+/,
                            required: true,
                            "err-msg": "Valid email is required"
                          }, null, 8, ["modelValue"]),
                          _createVNode(Input, {
                            ref_key: "passwordRef",
                            ref: passwordRef,
                            modelValue: password.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                            title: "Password",
                            placeholder: "Password",
                            type: "password",
                            required: true,
                            "err-msg": "Invalid Password"
                          }, null, 8, ["modelValue"]),
                          (loginData.value.hasRecaptcha)
                            ? (_openBlock(), _createBlock(GrecaptchaBox, {
                                key: 0,
                                ref_key: "grecaptchaRef",
                                ref: grecaptchaRef,
                                sitekey: loginData.value.recaptcha
                              }, null, 8, ["sitekey"]))
                            : _createCommentVNode("", true),
                          _createVNode(BaseButton, {
                            class: "sign-in-button sign-in-button--purple-bg",
                            "new-primary": "",
                            full: "",
                            large: "",
                            click: login
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode("Sign In")
                            ]), undefined, true),
                            _: 1
                          }),
                          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "forgot" }, [
                            _createElementVNode("a", { href: "/password" }, "Forgot Password")
                          ], -1))
                        ], 64))
                      : _createCommentVNode("", true),
                    (
                                loginData.value.emailLoginEnabled &&
                                loginData.value.hasOauthLogins
                            )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[7] || (_cache[7] = [
                          _createElementVNode("div", { class: "line" }, null, -1),
                          _createElementVNode("div", { class: "or-text" }, "or", -1),
                          _createElementVNode("div", { class: "line" }, null, -1)
                        ])))
                      : _createCommentVNode("", true),
                    (loginData.value.googleUrl)
                      ? (_openBlock(), _createBlock(BaseButton, {
                          key: 2,
                          click: () => redirectTo(loginData.value.googleUrl),
                          class: "sign-in-button sign-in-button--outline",
                          primary: "",
                          outline: "",
                          full: "",
                          large: ""
                        }, {
                          default: _withCtx(() => _cache[8] || (_cache[8] = [
                            _createElementVNode("img", {
                              class: "oauth-icon",
                              src: "/img/login/google-oauth-icon.svg"
                            }, null, -1),
                            _createTextVNode(" Sign in with Google ")
                          ]), undefined, true),
                          _: 1
                        }, 8, ["click"]))
                      : _createCommentVNode("", true),
                    (loginData.value.oktaUrl)
                      ? (_openBlock(), _createBlock(BaseButton, {
                          key: 3,
                          click: () => redirectTo(loginData.value.oktaUrl),
                          class: "sign-in-button sign-in-button",
                          primary: "",
                          outline: "",
                          full: "",
                          large: ""
                        }, {
                          default: _withCtx(() => _cache[9] || (_cache[9] = [
                            _createElementVNode("img", {
                              class: "oauth-icon",
                              src: "/img/login/okta-oauth-icon.png"
                            }, null, -1),
                            _createTextVNode(" Sign in with Okta ")
                          ]), undefined, true),
                          _: 1
                        }, 8, ["click"]))
                      : _createCommentVNode("", true),
                    (loginData.value.microsoftUrl)
                      ? (_openBlock(), _createBlock(BaseButton, {
                          key: 4,
                          click: () => redirectTo(loginData.value.microsoftUrl),
                          class: "sign-in-button sign-in-button--outline",
                          primary: "",
                          outline: "",
                          full: "",
                          large: ""
                        }, {
                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                            _createElementVNode("img", {
                              class: "oauth-icon",
                              src: "/img/login/microsoft-oauth-icon.png"
                            }, null, -1),
                            _createTextVNode(" Sign in with Microsoft 365 ")
                          ]), undefined, true),
                          _: 1
                        }, 8, ["click"]))
                      : _createCommentVNode("", true),
                    (loginData.value.samlSsoUrl)
                      ? (_openBlock(), _createBlock(BaseButton, {
                          key: 5,
                          click: () => redirectTo(loginData.value.samlSsoUrl),
                          class: "sign-in-button sign-in-button--outline",
                          primary: "",
                          outline: "",
                          full: "",
                          large: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(loginData.value.samlSsoName), 1)
                          ], undefined, true),
                          _: 1
                        }, 8, ["click"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (mfaSuccess.value && recoveryCodes.value)
                      ? (_openBlock(), _createBlock(MFASetupOk, {
                          key: 0,
                          "is-loading": isLoading.value,
                          codes: recoveryCodes.value,
                          "from-mfa-setup": false,
                          onOnDone: onDone,
                          onOnDownload: onDownloadRecoveryCodes
                        }, null, 8, ["is-loading", "codes"]))
                      : (isMfaRecoveryPage.value)
                        ? (_openBlock(), _createBlock(MFAVerifyRecoveryCode, {
                            key: 1,
                            onOnBack: mfaCancel,
                            onOnSubmit: onVerifyRecoveryCode
                          }))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "heading" }, "Enter Multi-Factor Code", -1)),
                            _createVNode(Input, {
                              ref_key: "mfaRef",
                              ref: mfaRef,
                              modelValue: mfa.value,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((mfa).value = $event)),
                              title: "Multi-Factor Authentication Code",
                              type: "number",
                              placeholder: "6 digit MFA code",
                              required: true,
                              "err-msg": 'Code cannot be empty'
                            }, null, 8, ["modelValue"]),
                            _createVNode(Checkbox, {
                              class: "remember-device-checkbox",
                              checked: mfaRememberDevice.value,
                              onChange: onChangeRememberDevice
                            }, {
                              default: _withCtx(() => _cache[11] || (_cache[11] = [
                                _createTextVNode("Remember this device for 30 days")
                              ]), undefined, true),
                              _: 1
                            }, 8, ["checked"]),
                            _createVNode(BaseButton, {
                              class: "sign-in-button",
                              "new-primary": "",
                              full: "",
                              large: "",
                              click: login
                            }, {
                              default: _withCtx(() => _cache[12] || (_cache[12] = [
                                _createTextVNode("Sign In")
                              ]), undefined, true),
                              _: 1
                            }),
                            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "forgot" }, [
                              _createElementVNode("a", { href: "/password" }, "Forgot Password")
                            ], -1)),
                            _createElementVNode("div", { class: "lost-access-legend" }, [
                              _createElementVNode("a", { onClick: onLostAuthenticatorLink }, "Lost Access To My Authenticator")
                            ])
                          ], 64))
                  ], 64)),
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "ask-logo" }, [
              _createElementVNode("a", {
                href: "https://www.asknicely.com",
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: "/img/asknicely_logo_grey.svg",
                  alt: "AskNicely"
                })
              ])
            ], -1))
          ], undefined, true),
          _: 1
        }, 8, ["logo"])
      ], 32)
    ])
  ]))
}
}

})